export const linkExpiryOption = [
  { value: 3, name: '3 Days' },
  { value: 7, name: '7 Days' },
  { value: 10, name: '10 Days' },
  { value: 30, name: '30 Days' },
];
